module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image15.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("KNOW YOUR PATTERNS:"), _c('br'), _c('span', {
    staticClass: "h2"
  }, [_vm._v("Fabric Design Fundamentals")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Fabric design is extraordinary because the artist trusts and encourages others to adapt the two-dimensional work on fabric into a new, three-dimensional form. The imagined end uses for the printed fabric—quilts, clothing, accessories, home décor projects, or anything else that can be made with fabric—can help guide and inspire the designer’s work.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Whether you’re printing a few yards in your home studio or 10,000 yards in a mill, fabric design involves the seamless repetition of one basic unit over the length of the cloth. In this chapter, you’ll get to know the conventions and terminology used by designers in creating patterns for fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("To create effective repeating fabric designs, you’ll make decisions about the following parameters:")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Directionality and orientation of the design on the fabric")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Motif type (geometric, floral, or novelty)")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Repeat type (square repeat, brick repeat, and others)")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Spacing and scale of motifs")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Color")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', {
    staticClass: "color1"
  }, [_vm._v("•")]), _vm._v(" Style")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("This chapter will help you understand these parameters so that you can make the best choices in your own work. Style is the least concrete and definable of all these parameters, but later in the chapter you’ll learn specific steps you can take to develop your artistic style. And color is such a complex topic that it gets its own chapter later in this section.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Beyond the Traditional Print: A Note about Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Digital textile printing (see Digital Printing, "), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_15_ch07#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 134")]), _vm._v(") is taking fabric design into the territory of fine art. As you read this, fashion and textile design pioneers, newly freed by digital technology from the restrictions imposed by mass production—namely, limitations on the number of colors and the requisite use of pattern—are completely changing the notion of what a fabric print is. Still, digital technology has its own limitations, and the traditional mass production methods will continue to dominate for the foreseeable future. It’s unlikely that the use of pattern in textile design will ever disappear, or even decline in the slightest. After all, pattern existed before mass production methods, and it will continue to be beautiful even as digital textile printing makes it unnecessary. Studying pattern design parameters is important because it helps to know the rules in order to break them in an interesting way.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("U.K. designers Melanie Bowles and Kathryn Round photographed a vintage dress once owned by a debutante and, using digital textile printing, created an engineered print on silk crepe de chine. The pattern pieces were assembled into a new dress for the exhibition “Trash Fashion: Designing Out Waste” at the Science Museum in London.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Design Parameters")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In this section, we’ll discuss design parameters—directionality and orientation, motif, repeat type, spacing and scale, and finally, style. If you’re not familiar with basic fabric terms, turn to A Look at Fabric Construction ("), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_13_ch05#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 99")]), _vm._v(") for a quick overview.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Directionality and Orientation")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The "), _c('i', [_vm._v("directionality")]), _vm._v(" of a print refers to the number of ways you can rotate the fabric and keep the print looking the same. As you will see, directionality is both an aesthetic and a functional choice.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DIRECTIONAL PRINTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Most directional prints are oriented "), _c('i', [_vm._v("with-the-roll")]), _vm._v(" (with the lengthwise direction of the fabric). If you drew an imaginary line through a motif, such as a tree, from its top to its bottom, that line would be parallel to the selvage. Directional prints can be "), _c('i', [_vm._v("one-way")]), _vm._v(" or "), _c('i', [_vm._v("two-way.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("One-way prints")]), _vm._v(" can only be turned one way; otherwise the print looks upside down or sideways. Even if most motifs are two-way or nondirectional, if just one motif in a design is oriented one way, the entire design is considered one-way. Since this is how most of the real world is oriented, it’s the most natural direction in which to lay out prints. However, one-way fabric presents challenges for sewists. This is because cutting layouts for many types of projects are designed so that pieces are oriented lengthwise and crosswise, right side up and wrong side down, to minimize yardage requirements. But with one-way fabrics, all pieces must be oriented the same way, and therefore the project may require more yardage.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Two-way prints")]), _vm._v(" look the same whether they’re turned right side up or upside down, so they are less limiting in their project layouts than oneway fabrics. One-way (and sometimes two-way) fabrics may require extra attention for patchwork projects. Pieces can all be cut with the lengthwise grain if the project has a definite top and bottom, but quilters may be able to cut out a portion of their pieces the “wrong” way, effectively upgrading the fabric to a two- or four-way print.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NONDIRECTIONAL PRINTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("For apparel manufacturers and home sewists alike, nondirectional prints are favored because sewing pattern pieces may be cut out in any direction, translating to a smaller investment and less waste. Nondirectional prints include two subtypes: tossed and four-way.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Tossed prints")]), _vm._v(" can be rotated in any direction, including on the bias, and look the same. Pieces may be cut in any direction, so there is less waste. Visually, they serve as an oasis; the eye can ramble around them in a leisurely way. Spaced, tossed prints often strongly communicate “I’m fun and carefree!” so the designer must decide if that message is consistent with the other aspects of the design.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Four-way prints")]), _vm._v(" look the same whether they are oriented at 0°, 90°, 180°, or 270°, and the eye will typically travel along these straight lines. Tartan plaids are one example of this category. Though four-way prints can’t be spun any which way like a tossed print, they are functionally nondirectional because most pieces are cut true to the lengthwise or crosswise grain. Bias-cut pieces will look different, but that is usually desirable.")]), _vm._v(" "), _c('h4', {
    staticClass: "tiphead"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('b', [_vm._v("DESIGNER TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tipb"
  }, [_vm._v("Just because a print might not look the same when it is oriented upside down or sideways doesn’t necessarily mean that only one orientation is “correct” or usable. For example, a stripe could be oriented in four or more directions and look just fine, but it is still considered a two-way print.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("One-way print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Two-way print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Tossed print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Four-way print")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("One-way print: Corduroy for Robert Kaufman Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Tossed print: Falling Leaves from Kanon collection for Daiwabo")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Two-way print: Homey Basics collection for Daiwabo")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("Four-way print: Pears from Metro Market for Robert Kaufman Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Craft panel")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Cheater print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Border print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image23a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("All-in-one print")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("Craft panel: Clauss the Raccoon from Let’s Stitch kit for Egg Press")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Border print: Grassy Plain from Echiro Fall 2009 collection by Etsuko Furuya for Kokka")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Cheater print: Trefle collection for Kokka")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("All-in-one print: Petite Ecole for Kokka")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHER TYPES OF PRINTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Railroaded prints")]), _vm._v(" feature motifs that run parallel to the selvage. This type of print is often found in upholstery fabrics: The fabric can cover the entire back of a sofa, so there is no need for cutting and seaming.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Border prints")]), _vm._v(" are railroaded by nature and are designed with specific end uses in mind, such as pillowcases, tablecloths, skirts, totes, and aprons. The decorative border travels along one or both selvages (sometimes the two borders are different), and the remainder is solid or filled with a quieter print.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Designed with even more specific end uses in mind are "), _c('i', [_vm._v("craft panels, all-in-one prints,")]), _vm._v(" and "), _c('i', [_vm._v("cheater prints.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Craft panels")]), _vm._v(" include all the ready-to-sew pieces for a project, such as a stuffed toy, printed directly onto the fabric. Related to these are placement prints, which are not repeating patterns at all (though they might have repeating motifs within them). They might be printed directly onto a finished product, such as a T-shirt or tote bag, or printed along the length of a cloth that is then cut apart and hemmed, as in the case of scarves or tea towels.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Engineered prints")]), _vm._v(" are fashion’s version of craft panels. Pieces for a garment, such as an apron or dress, are printed directly onto the fabric, with the print already filled in.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("All-in-one prints")]), _vm._v(" (which are usually railroaded) include a mini-collection of different prints all on one length of fabric. The all-in-one print has come to recent popularity in Japan, and I think it’s a great idea for any designer to consider.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("A cheater print")]), _vm._v(" is mock patchwork, which might be simple squares or complicated traditional quilt patterns like the Double Wedding Ring. The quilter can skip the labor of piecing and go straight to layering and quilting the piece by simply stitching in-the-ditch between print “patches.” Cheaters can also be cut apart for scrappy projects. Like all-in-one prints, they are a great way to incorporate several prints into one length of cloth.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Motif Types")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The term "), _c('i', [_vm._v("motif")]), _vm._v(" refers to any element in a design. It typically applies to a repeated element, but we’ll use the term for non-repeated elements as well. It’s hard to believe, but textile design involves only three broad categories of motifs: geometric, floral, and novelty. Really, you could narrow it down to two: abstract (geometric) and representational (encompassing both floral and novelty). But floral motifs have been so prevalent throughout eras and cultures that they have been granted a class of their own.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Geometrics.")]), _vm._v(" When you think of geometrics, the first things that probably come to mind are the classics—polka dots, stripes, plaids, checks, and diamonds. Geometric patterns can be simple or complex, regimented or random, straight or curvy, or anywhere in between. Some geometric patterns and motifs have real-world associations, but those associations tend to be loose and mutable. For example, tartan plaids originate from and are still strongly associated with Scotland, but they are used so widely that the association is often lost. As such, geometrics are the most versatile and universal of prints.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("A. Unknown")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("B. Unknown")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("C. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("D. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("E. Gingham by unknown manufacturer")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("F. Unknown")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("G. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("H. Vintage barkcloth")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("I. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("J. Glimmer by Nancy Mims for Mod Green Pod")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("K. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("L. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("M. Unknown")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("N. Argyle Plaid from Katie Jump Rope by Denyse Schmidt for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("O. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagek",
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Florals.")]), _vm._v(" From cherry blossoms to cabbage roses to ultragraphic blooms, floral prints and patterns are an inextricable part of nearly every design tradition, and just about every fabric collection too. Flowers are feminine, beautiful, and classic; and because of their universal appeal, it’s no wonder they get a category all to themselves. And it’s a category with more gravitational pull than geometrics—if you toss daisies over a polka dot background, it’s considered a floral print, not a geometric.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("A. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("B. By Paula Smail for Henry Road")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("C. Giselle Collection by Jessica Swift for Red Rooster Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("D. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("E. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("F. Vintage barkcloth")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("G. Lightning Bugs and Other Mysteries by Heather Ross for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("H. Old New Spicy Scrap collection for Lecien")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("I. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("J. Secret Garden for Alexander Henry Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("K. Graphic Roses by Bari J. for Windham Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("L. Unknown Japanese cotton")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("M. Wild Thyme by Carolyn Gavin for P&B Textiles")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("N. Medallion Rose from Temple Flowers by Amy Butler for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("O. Vintage barkcloth")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Novelty,")]), _vm._v(" or “conversational,” prints encompass virtually everything else that doesn’t fall into the geometric or floral categories. The theme of the motifs (trains, planets, cities) narrows the potential audience for the fabric, but novelties tend to speak more loudly than the other two types, both visually and as an emblem of identity for the wearer or user of the fabric. (And speaking of gravitational pull, the novelty category has the strongest of all. If you throw a duckling in with those daisies and dots, you’ve got a novelty print.) While several classic themes like old West, kitchen, nautical, zoo, and holiday motifs will always enjoy an audience, the popularity of others can fade in and out with fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("A. Lovebirds for Michael Miller Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("B. Hush Puppies from Nicole’s Prints for Alexander Henry Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("C. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("D. Unknown Japanese fabric")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("E. From Vintage Collection for American Folk & Fabric, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("F. From Northern Europe collection for Yuwa Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("G. Peacock by Trois Miettes")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("H. Unknown Japanese fabric")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("I. Vintage")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("J. Belbird by Melissa Bombardiere")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("K. Corduroy print by unknown")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("L. Gnomes from Lightning Bugs and Other Mysteries by Heather Ross for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("M. Unknown Japanese fabric")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("N. Hana no Naka by Megumi Sakakibara for Kei Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("O. From Petit Village byTimeless Treasures Fabrics")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('b', [_c('i', [_vm._v("Repeat Types")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Square repeat print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Half-drop repeat print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Brick repeat print")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Snip Snip from Wonderland by MoMo for Moda Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("Square repeat print: From Remix by Ann Kelle for Robert Kaufman Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Half-drop repreat print: From Freebird by MoMo for Moda Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("Brick repeat print: Canyon Flutter from Natura for Alexander Henry Fabrics")]), _vm._v(" "), _c('h4', {
    staticClass: "tiphead"
  }, [_c('b', [_vm._v("DESIGNER TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tipb"
  }, [_c('i', [_vm._v("A spaced, single-motif square repeat is usually the first type of pattern a beginner makes, but this type is relatively rare in retail fabrics, because these grid-based designs can be visually jarring. These repeats work only with certain styles, motif types, and applications, such as small-scale motifs (in which the “blockiness” decreases) or larger-scale, graphic, clean-lined motifs, like the example below. It’s easy to tell when a designer is")]), _vm._v(" intentionally "), _c('i', [_vm._v("harnessing the power of a spaced square repeat rather than just using it for lack of other ideas. Varying the color or some other detail of some of the motifs adds an interesting element of flow.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('i', [_vm._v("Repeat Types")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In typical pattern designs, motifs must be arranged into repeating units to be printed continuously and seamlessly on a length of cloth. Here, you’ll learn about the types of repeats—square, half-drop, brick, and others. In Step-by-Step Design ("), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_09_ch02#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 32")]), _vm._v("), you’ll find hands-on instructions on how to create these repeats and ensure that the overall pattern is successful.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Square repeat.")]), _vm._v(" This type, also referred to as the block, side, or straight repeat, is the simplest, most basic repeat. The motif or motifs are built within or overlapping a foundational rectangle (or square or parallelogram), and that rectangle is repeated as a simple grid. The grid may be invisible or incorporated overtly as part of the design. All printing methods except digital require that the basic design repeat eventually be built up into a rectangle, so really, all repeating patterns are variations of a square repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Half-drop.")]), _vm._v(" Take alternating columns of the square repeat grid and push them down a fraction of the block height—a quarter, a half, three quarters—and you have a drop. Half-drops, where the design is pushed down half of its height, are the most common type of drop and the most common type of repeat overall. Even the simplest of designs draws the eye diagonally in both directions, creating a pleasant flow and balance. It’s also easier to camouflage the repeat this way, because it breaks up motifs that, if lined up straight, would cause unintentional striping or "), _c('i', [_vm._v("tracking.")]), _vm._v(" (For more on this topic, see Proofing Repeats: Why and How, "), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_09_ch02#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 55")]), _vm._v(".) Depending on the motifs, if the repeat unit drops anywhere between a full- and a half-drop, strong one-way diagonals are formed.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Brick repeats")]), _vm._v(" involve the same concepts as drops, but the alternating pattern rows, instead of the columns, are staggered.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('i', [_vm._v("Random versus Set Layouts")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Diamond/lozenge pattern")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Hexagon pattern")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image38.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Other tessellation pattern")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Ogee pattern")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Scales or clamshell pattern")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Stripe pattern")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("Diamond/lozenge pattern: From Pretty Please by Jennifer Paganelli for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Hexagon pattern: From Nest by Tula Pink for Moda Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Other tessellation pattern: From August Fields by Amy Butler for Rowan Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Ogee pattern: From Midwest Modern 2 by Amy Butler for Rowan Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Scales/clamshell pattern: From Charm by Amy Butler for FreeSpirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("Stripe pattern: From Free to Grow by Nancy Mims for Robert Kaufman Fabrics")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('i', [_vm._v("Random versus Set Layouts")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Motifs can be laid out so that they look randomly scattered over the cloth or so that they appear set in a grid or other arranged pattern. The choice between the two is independent of other design parameters.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("In "), _c('i', [_vm._v("random")]), _vm._v(" layouts, the most important factor is that the repeat is not supposed to be obvious. The eye should flow over the cloth, and the viewer should have to work a bit to find where the design begins to repeat. The designer achieves this effect by strategically overlapping motifs over the edges of the repeat boundaries, a technique that you’ll learn all about in Step-by-Step Design ("), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_09_ch02#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 32")]), _vm._v("). Square and drop repeats are most commonly used, though it’s possible to use the brick repeat as well.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("In contrast, if repetition is flaunted as an important element of the design, the design is said to be in a "), _c('i', [_vm._v("set layout.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Square, drop, and brick repeats can form the underlying grid of a set layout (but see the Designer Tip on "), _c('a', {
    attrs: {
      "href": "#/html/9781607056188_08_ch01#page_20"
    }
  }, [_vm._v("page 20")]), _vm._v(" for notes on using the square repeat for set layouts). Other interlocking shapes, sometimes referred to as "), _c('i', [_vm._v("tilings")]), _vm._v(" or "), _c('i', [_vm._v("tessellations,")]), _vm._v(" are often used as the basis for set layouts as well. For example, take a square grid, turn it 45°, and you have a basic "), _c('i', [_vm._v("diamond")]), _vm._v(" pattern. Imagine taking that grid and smushing it from the side or top to make a skinnier or fatter diamond; now you technically have "), _c('i', [_vm._v("lozenges,")]), _vm._v(" though most people will still call them diamonds. Smooth the lines of the diamond into curves, and you have "), _c('i', [_vm._v("ogees,")]), _vm._v(" which look like onions. "), _c('i', [_vm._v("Triangles, hexagons,")]), _vm._v(" and "), _c('i', [_vm._v("scales")]), _vm._v(" (or "), _c('i', [_vm._v("clamshells)")]), _vm._v(" are other classic set layout types. "), _c('i', [_vm._v("Stripes")]), _vm._v(" are probably the most familiar set layout type. They are one- or two-way designs composed of long, narrow bands of motifs or solid color. These bands can be straight, wavy, or jagged.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Geometric motifs are the ones most commonly used in set layouts, but motif choice is almost totally independent of repeat and layout choice. As an example, simply imagine a stylized flower repeated in a diamond grid, or a tossed dot print.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('i', [_vm._v("Spacing")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image40.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("A. The motifs in this vintage print are spaced apart from one another and seem to float against the white background.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("B. This vintage floral is more densely packed, though a little bit of background is showing.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("C. The simple patterned background of this vintage floral adds subtle interest.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("D. The background leaf motifs add flow and dimension to this vintage floral print, as if you’re looking down into a flower bed.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("E. The flower motifs here are connected with flowing stems and leaves in this vintage fabric.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('i', [_vm._v("Scale")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image41a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Small-, medium-, and large-scale patterns")]), _vm._v(" "), _c('p', {
    staticClass: "normal1d"
  }, [_vm._v("Small-scale print: From Trefle collection for Kokka")]), _vm._v(" "), _c('p', {
    staticClass: "normal1r"
  }, [_vm._v("Medium-scale print: Matroyska Dolls and Doilies for Kokka")]), _vm._v(" "), _c('p', {
    staticClass: "normal1e"
  }, [_vm._v("Large-scale print: From Trefle collection for Kokka")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Spacing and Scale")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Motifs can be "), _c('i', [_vm._v("packed")]), _vm._v(" together, showing little to no background, or "), _c('i', [_vm._v("spaced,")]), _vm._v(" showing lots of background. Designs with alternating packed and spaced areas are called "), _c('i', [_vm._v("open-and-closed.")]), _vm._v(" They might flow together via "), _c('i', [_vm._v("continuous,")]), _vm._v(" connecting elements or appear to float on their own. These are aesthetic choices that don’t have strong correlations to a fabric’s end uses.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('i', [_vm._v("Note:")])])]), _vm._v(" "), _c('i', [_vm._v("Allover print")]), _vm._v(" or "), _c('i', [_vm._v("allover pattern")]), _vm._v(" is often used to refer to packed designs. But I’ve also heard it used to refer to random (as opposed to set) layouts and to distinguish edge-to-edge printed cloth from placement (isolated) or border prints. To avoid confusion, I’ve chosen to use what I consider the more descriptive terms in each case.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Scale, however, is "), _c('i', [_vm._v("very")]), _vm._v(" important in relation to the end uses of a fabric—whether it is used in apparel, home dec, or quilting. Motifs can range from minuscule (pin dots) to the supergraphics popularized by Marimekko in the mid-to-late twentieth century. Though scale is somewhat relative depending on application (e.g., a medium-scale quilting print might be considered a small-scale home dec print), the rough rule of thumb is as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Small-scale motifs = ½″ square and under")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Medium-scale motifs = greater than ½″ square 2″-4″ square")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Large-scale motifs = greater than 4″ square")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01_02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Developing Your Style")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("This chapter has covered the more definable parameters of fabric design, but the most important part—style—is impossible to learn from a book. Developing one’s artistic voice and style is an individual journey. Like all creative ventures, it’s partially about inborn talent. But mostly, it’s about hard work, practice, and a desire to explore, learn, and synthesize influences in unique ways.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Following are some concrete things you can do to push yourself forward on that journey.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Cast your net widely.")]), _vm._v(" Push beyond the world of fabric itself. Get out of your house, travel (even if only in your own town), learn something new, work in a variety of media— paint, paper, film, music—anything that strikes your fancy. Carry a camera and notebook everywhere. Strive for inspiration from intangibles like ideas, experiences, and feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Set constraints.")]), _vm._v(" As you’ve begun to see, outside factors (end use and printing methods) set some constraints for you in regard to parameters like motif type, scale, and directionality. To avoid “option paralysis”—becoming overwhelmed with choices and therefore paralyzed in decision making—it helps to set constraints. Especially when it comes to the less objective aspects of design (theme, color, and style), imposing constraints on yourself can help you focus and unleash your creativity. Focus on a specific inspiration to guide the way toward a design. Put together an inspiration board. Choose a color palette and challenge yourself to stick with it. On slips of paper, write various parameters (motif type, number of colors, repeat type, media to use). Put them in a jar and draw one at random. They might lead to some genius work, but even if they turn out to be the wrong choices, they often will make the right choices more clear to you.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Join or start a group.")]), _vm._v(" Gather like-minded designers and artists for regular, face-to-face gatherings. Discuss goals, share inspiration, constructively critique each others’ work, and call each other out on your artistic demons.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01_03"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DESIGNER ROUNDTABLE:")]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "h3"
  }, [_vm._v("Obstacles to Creativity")])]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("What are your biggest creative obstacles?")]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("Option paralysis?")]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("Time management?")]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("Designer’s block?")]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("Something else?")]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("How do you get over them?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0120.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I think every artist runs into one or all of these problems from time to time. Usually for me it’s having enough time. But it’s important to take a break from what you are doing once in a while to relax and clear your mind. A cup of tea in the garden, a weekend away with friends—having some time for yourself is very important so you don’t get burned out and you can continue to enjoy the work that you do. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMY BUTLER")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0132.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I think creative blocks are my biggest obstacle, because sometimes I can let fear and doubt take over. My most surefire way to get over it is to just start creating something. Once I’m working, the fear goes away and the creativity comes, but sometimes it’s hard to get to the place of just starting even though I don’t have any idea of what I’m going to create. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JESSICA SWIFT")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0123.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("When option paralysis hits, I ask myself, Which design idea do I see most clearly? Which can I create by getting the most value for the time I’m spending? Which option is the most commercially viable? and, Which concept fits with the needs I have to fulfill now with deadlines coming up? I usually get over it by answering these questions, creating a plan of action with deadlines, and starting to create! "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOSEPHINE KIMBERLING")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0126.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("The biggest challenge to my creativity is having too many distractions or tasks demanding my attention. I like to be able to really focus when I’m designing, so that I can visualize and be imaginative. In order to keep my ideas organized, I often put together an idea board with images and sketches that relate to the designs and collection I’m working on. Then I will choose a solid block of time—a day or week—when I can focus "), _c('b', [_vm._v("on")]), _vm._v(" designing. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JENNIFER MOORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0118.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("For me it’s definitely inspiration overload. Everywhere I turn I can come up with a new print idea. The key for me is to make cohesive groups. If I can envision a series of prints revolving around one theme—the seashore, for instance—I will concentrate my focus and begin researching images for that specific idea. This can bring additional overload of concepts, but as I develop prints an overall “look” begins to emerge. There are always many more discarded prints than what will wind up in the final selection; for me, it’s nearly four discarded to one kept. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MICHELLE ENGEL BENCSKO")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0121.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I love planning and research, so the biggest obstacle for me has always been that I think about a project too much before I do it. Sometimes it never gets done because it just never got started! I’ve learned that sometimes I just have to jump in and figure out things as I go. It may not turn out as well as I would like, but I always feel better once it’s done. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JASONDA DESMOND")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0127.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I never have a shortage of ideas, but sometimes I have too many, and I have trouble deciding which way to go with new collections. If I give myself too much time, I will second-guess myself repeatedly. If I don’t have enough time, I feel rushed. I like to complete a collection and then wait a couple of weeks, look at it again, and see how I feel. I need plenty of time both with the collection and away from the collection before I can feel comfortable turning it in. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JENEAN MORRISON")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("Generally it is inspiration overload—too many wonderful things to work into a repeating pattern and print, and it can be really hard to choose. Sometimes we do a Google search to see if too many other people are using the same motif, but most of the time we just go with our gut feeling and draw what appeals to us. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROUNNA KHOUNNORAJ AND ROISIN FAGAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0115.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("My biggest obstacle is probably negative self-talk, which can be overwhelming if I let it be. I tend to have short bouts of it, but mostly I ignore it. You have to be tenacious to get anywhere in this business, and you can’t let a little bit of insecurity get in the way. So much of that negative thinking is brought on by looking to the outside for approval or looking at the work of others and doing that self-destructive, “if only I was like so-and-so” kind of thinking. I have to remind myself to have grace when it comes to how I look at myself, and to only look inside for approval. As I get older, I’m doing a much better job of it. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BARI J. ACKERMAN")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01_04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("Trends: Set, Follow, or Ignore?")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("It can take a year or more for a traditionally manufactured fabric collection to go from conception to market, and a lot can happen in that time. Of course, nobody can predict the future and know for sure what will be a hit and what will flop. But current trends on the fashion runways, on the streets of major urban centers, and from all kinds of creative industries take some time to trickle down to the public and translate to mass-market production in a predictable way. There is an entire industry devoted to trend analysis and prediction, based not on crystal-ball gazing but on very objective analysis of market dynamics and consumer spending. Of course, the average individual doesn’t have access to these services, but you can at least keep up with the cutting edge by following fashion and design media (magazines and blogs). Create inspiration boards or scrapbooks devoted to trends that inspire you. Interpreting trends in your own way is just one way to set creative constraints for yourself, but it’s one that can better ensure market success.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch01_05"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DESIGNER ROUNDTABLE:")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h3"
  }, [_vm._v("Trends and You")])]), _vm._v(" "), _c('p', {
    staticClass: "normal3a"
  }, [_vm._v("What role do current trends and trend prediction play in your work?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0131.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("Many years ago some very influential trend/color forecasters came by my booth at the International Contemporary Furniture Fair and took pictures for their forecasting publications. I realized that the best thing for me to do was pay attention to what I like and just get it out there. If I start thinking too much about what others think will be fashionable in two years when something I am working on will hit the market (and about what a mass-market audience may like as opposed to a higher-end audience), I just get confused. I’m hired because people like what I do, and I try to toe that line above all else. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DENYSE SCHMIDT")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0127.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_c('i', [_vm._v("I like to research and stay on top of trends, but I wouldn’t say they play a large role in my fabric design. If trends work their way into my fabric designs, it comes more in the form of color than in the form of motifs. I read style blogs and love to look at the latest fashions and home décor magazines, so I am sure some of that works its way into my designs—although it is not something I set out to do.")]), _vm._v(" "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JENEAN MORRISON")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0117.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("This is a tricky one to answer. It seems like there are so many collections coming out so frequently that there must be something for everyone. On the flip side, there is substantial competition. With my first collection I didn’t think too much about trends—it was enough to design a whole collection that I was excited about! Going forward, though, I have put more thought into trends—though to be honest, I am still figuring it out. One nice aspect of the relationship I have with my manufacturer is that they have been doing this a long time and have a more intimate knowledge of the market as a whole and a better idea of trends as they relate specifically to fabric. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MO BEDELL")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("None, really. We don’t follow any particular consumer trending sites or publications. We want our work to appeal to people and be relevant in the long term, rather than have a short-term, disposable success. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROUNNA KHOUNNORAJ AND ROISIN FAGAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0123.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("Current trends and trend prediction play strongly in my work. I’m very attracted to trends and forward thinking and am always keeping my eye open for what’s coming down the pike. I like using trends as a guide and launching-off point—like a compass—to help direct my work. However, I also don’t particularly like to follow a trend exactly, as I enjoy the challenge of finding my own voice among the trends. I also won’t bend my style toward a trend if it’s not truly me, as I’m all about being artistically true to who I am. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOSEPHINE KIMBERLING")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0128.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("It’s impossible not to see what’s going on around you, so that does play into it. I think the most successful designers are the ones who stay true to themselves and their own personal style. They are the people who set the trends. It’s really important to know what’s going on, but trend chasing will only leave a designer looking like they don’t have their own voice. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TULA PINK")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0116.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I don’t attempt to forecast or follow trends. As a visual omnivore, I am constantly taking everything in, so I can’t help but notice what’s out there and be influenced by it in some way. But I indulge in my own color sense and let the designs happen organically, to let them be as authentically “me” as they can be. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MELISSA AVERINOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image0118.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normali"
  }, [_vm._v("I’d say it’s quite relevant. I definitely don’t want to offer something passé or so far ahead of the curve—or off the grid entirely—that people will not be interested. If birds are popular and birds are something I’m drawn to, I’ll do my best to include them. If the trend was zebras but I didn’t really feel an affinity with zebras, I would look elsewhere. Once I spot the trends, I tend to hop off at the first stop and then take my own path the rest of the way home. I think the most successful collections blend trend and individual taste and style: they are those that mesh multiple ideas into one, creating a fresh perspective on what’s current. "), _c('span', {
    staticClass: "color1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MICHELLE ENGEL BENCSKO")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01_06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Copyright Primer")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("It should go without saying, but I’m surprised at how often it doesn’t: "), _c('i', [_vm._v("Do your own work.")]), _vm._v(" Copyright law is far too complicated for the scope of this book, but a few myths related to copyright and fabric design come up repeatedly.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Myth #1:")]), _vm._v(" "), _c('i', [_vm._v("If I change someone else’s work by 10 percent, that’s enough to make the work my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('i', [_c('b', [_vm._v("Reality:")])]), _vm._v(" There are no mathematical formulas used to determine copyright infringement. If you copy or distribute some or all of a copyrighted work without the permission of its original creator, you may be held liable for copyright infringement.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Myth #2:")]), _vm._v(" "), _c('i', [_vm._v("I can use clip art in my designs.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('i', [_c('b', [_vm._v("Reality:")])]), _vm._v(" Not necessarily. Read the terms of use that come with the book, software, or website from which the clip art originated. Sometimes clip art is in the public domain, and sometimes you are not allowed to use it if you are selling whatever product the art is printed on.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_vm._v("Myth #3:")]), _vm._v(" "), _c('i', [_vm._v("If the source of the work isn’t identified, the work is free for me to use.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('b', [_c('i', [_vm._v("Reality:")])]), _vm._v(" Definitely not true. It seems obvious that you can’t use work you find in a book or other publication, but less obvious for things you find on the Internet. The Internet provides easy access to an endless array of amazing, inspiring imagery. The urge to possess these works is normal, and copying is the path of least resistance. But no good comes of copying, and you "), _c('i', [_vm._v("will")]), _vm._v(" get caught if you appropriate others’ work as your own. It hurts the livelihood of the artist and hinders your own creative growth, so just don’t do it. Instead, think about the less tangible aspects that draw you to the work—the lines, the mood, and so forth—and use that as a jumping-off point for your own work. That’s the essence of inspiration.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Reproducing Vintage Designs")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("What if you fall in love with a vintage fabric design and want to create your own version of it? The textile industry is full of vintage reproductions and adaptations, and you might wonder why people are free to copy these designs.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Up until the mid-1900s, fabric designers were usually anonymous, and fabric patterns were typically not copyrighted. Then big-name designers began to emerge, and identifying information and copyright notices started to appear on some fabric selvages. Copyrighting fabric designs wasn’t common practice until recent decades.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Today, there are probably millions of yards of fabric circulating that have no identifying information. Some are modern fabrics and their print designs are copyrighted; others are vintage and belong to the public domain if certain conditions are met. Current U.S. copyright law sets the term of copyright to the life of its creator plus 70 years, but works of corporate authorship (a design copyrighted by a company) are protected for 95 years after printing or 120 years after creation. However, depending on the original publication (printing) date and compliance with copyright registration formalities, many works created up to 1989—including fabric prints—are now in the public domain, meaning that you can use them without obtaining permission. See the chart (next page) for details.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("The problem with unidentified vintage fabric designs is that there is no way for the average person to reliably identify the date of original “publication” (printing) of a fabric. However, you can make an educated guess based on colors, weave, design styles, and other factors. (For books on dating fabric, see Resources, "), _c('span', {
    attrs: {
      "href": "#/html/9781607056188_19_res#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 158")]), _vm._v(".) If the work was registered after January 1, 1978, copyright information is searchable online through "), _c('a', {
    attrs: {
      "href": "http://www.copyright.gov/records",
      "target": "_blank"
    }
  }, [_vm._v("www.copyright.gov/records")]), _vm._v(". For works before 1978, you must perform the search in person at the Library of Congress in Washington, D.C., or pay to have it done for you.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image59.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("If you want to risk reproducing a vintage textile design, be sure to document your attempts to identify the design’s origins and obtain permissions to reproduce it. Should you be accused of copyright infringement, you will at least have evidence that you made a good-faith effort to follow the law. This may help your case, but it may not, as intention is not usually taken into consideration in copyright infringement lawsuits. In short, reproduce vintage designs at your own risk.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("And remember that even if you alter the design, you only own the copyright to your changes—not to the original work. If the original work is in the public domain, then anyone is free to reproduce it.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "html/images/image60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figurecaption"
  }, [_vm._v("Very few vintage fabrics have identifying or copyright information printed in the selvage, as these do.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Protecting Your Original Work")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("According to current U.S. intellectual property law, once you create an original design in a tangible form (not just an idea), the copyright to it belongs to you for the rest of your life plus 70 years. This holds even if you do nothing to notify people of those rights. But it is still prudent, especially if your fabrics will be released to the public, to print the selvage with your name, your company’s name, the name of the design, and a copyright symbol with the year of creation. It’s even more prudent to register the copyright with the U.S. Copyright Office. At the time of this writing, the cost to register a basic copyright for a single print or a collection of prints online is $35. The primary benefits of registering are twofold: It creates a public record of your copyright that will last in perpetuity, and it gives you the ability to sue infringers. You "), _c('i', [_vm._v("must")]), _vm._v(" register the work in order to sue. The damages you can claim depend on the timing of the registration, so don’t wait until your rights are violated to file your copyright.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6850a192","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607056188_08_ch01.vue
// module id = 72
// module chunks = 0